/**
 * Determines if 2 sets contain the same values
 *
 * @param s1 first set
 * @param s2 second set
 * @returns boolean if sets are equal
 */
export function areEqualSets<T>(s1: Set<T>, s2: Set<T>): boolean {
    return s1.size === s2.size && Array.from(s1.values()).every((v) => s2.has(v));
}
